import { queryOptions } from '@tanstack/react-query';
import { authBaseURL } from '../../constants/hosts';
import * as users from '#proto/index.qonto.account_management.users.firstparty.v2';
import { client } from '#queries/utils';

function getMe() {
  return queryOptions({
    queryKey: [...usersQueries.all],
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const result = await client(`${authBaseURL}/v2/users/me`);

      return users.ApiGetUserResponse.fromJSON(result);
    },
  });
}

export const usersQueries = {
  all: ['current-user'] as const,
  getMe,
};
